/** Table-driven interval strategy returning the smallest entry ≥ target. */
export class SteppingIntervalStrategy {
    intervals_;
    targetScreenPx_;
    constructor(intervals, targetScreenPx) {
        this.intervals_ = intervals;
        this.targetScreenPx_ = targetScreenPx;
    }
    getInterval(resolution) {
        const target = resolution * this.targetScreenPx_;
        const table = this.intervals_;
        for (let i = 0; i < table.length; i++) {
            if (table[i] >= target)
                return table[i];
        }
        return table[table.length - 1];
    }
    getMinorInterval(majorInterval) {
        return majorInterval / 5;
    }
}
//# sourceMappingURL=SteppingIntervalStrategy.js.map